<template>
  <div class="min-h-screen px-6 py-8 md:px-10">
    <div class="w-full space-y-6">
      <Breadcrumb :links="breadcrumb" />

      <div class="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <h1 class="mt-2 text-3xl text-gray-900">
            Relatório Diário
          </h1>
          <p class="mt-2 max-w-2xl text-sm text-gray-500">
            Consulte os envios, respostas e totais do relatório diário.
          </p>
        </div>
      </div>

      <div class="rounded-2xl border border-red-200 bg-red-50 px-5 py-4 text-sm text-red-800">
        O relatório diário pode sofrer delay ao ser tirado no mesmo dia. Para conversas em dias anteriores, não há alteração no fluxo.
      </div>

      <div class="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
        <div class="p-6">
          <form>
            <div class="grid grid-cols-1 gap-4 md:grid-cols-4">
              <div v-if="isRangeUser" class="flex flex-col gap-1">
                <label for="dataInicio" class="text-sm font-medium text-gray-500">Data inicial</label>
                <input
                  v-model="form.dataInicio"
                  type="date"
                  name="dataInicio"
                  id="dataInicio"
                  class="h-11 rounded-xl border border-gray-200 px-4 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
                />
              </div>

              <div v-if="isRangeUser" class="flex flex-col gap-1">
                <label for="dataFim" class="text-sm font-medium text-gray-500">Data final</label>
                <input
                  v-model="form.dataFim"
                  type="date"
                  name="dataFim"
                  id="dataFim"
                  class="h-11 rounded-xl border border-gray-200 px-4 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
                />
              </div>

              <div v-else class="flex flex-col gap-1">
                <label for="data" class="text-sm font-medium text-gray-500">Acompanhar data</label>
                <input
                  v-model="form.data"
                  type="date"
                  name="data"
                  id="data"
                  class="h-11 rounded-xl border border-gray-200 px-4 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
                />
              </div>

              <div v-if="$store.state.user.admin" class="flex flex-col gap-1">
                <label for="centrocusto-select" class="text-sm font-medium text-gray-500">Centro de custo</label>

                <div class="relative group">
                  <select
                    v-model="form.centrocusto"
                    id="centrocusto-select"
                    name="centrocusto"
                    class="w-full h-11 px-4 pr-10 border border-gray-200 rounded-xl bg-white bg-none text-gray-700 shadow-sm appearance-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100 cursor-pointer"
                  >
                    <option :value="null">Todos</option>
                    <option
                      v-for="centro in centroscusto"
                      :key="centro._id"
                      :value="centro._id"
                    >
                      {{ centro.nome }}
                    </option>
                  </select>

                  <svg class="select-icon h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>

              <div class="flex items-end">
                <button
                  @click="list"
                  type="button"
                  class="h-11 w-full rounded-xl font-medium text-white transition"
                  :style="{ backgroundColor: primaryColor }"
                  @mouseenter="$event.target.style.backgroundColor = mixPrimaryColor('#111827', 0.2)"
                  @mouseleave="$event.target.style.backgroundColor = primaryColor"
                >
                  Gerar relatório
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-5">
        <div class="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
          <p class="text-sm font-medium text-gray-500">Total upload</p>
          <p class="mt-2 text-2xl font-semibold text-yellow-600">{{ totalEnvios }}</p>
        </div>

        <div class="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
          <p class="text-sm font-medium text-gray-500">{{ $store.getters.rotuloEnvio('Total upload enviado', 'Total upload enviado para fila') }}</p>
          <p class="mt-2 text-2xl font-semibold text-blue-700">{{ totalEnviados }}</p>
        </div>

        <div class="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
          <p class="text-sm font-medium text-gray-500">{{ $store.getters.rotuloEnvio('Total iniciado manualmente enviado', 'Total iniciado manualmente enviado para fila') }}</p>
          <p class="mt-2 text-2xl font-semibold text-blue-700">{{ totalIniciadoManual }}</p>
        </div>

        <div class="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
          <p class="text-sm font-medium text-gray-500">{{ $store.getters.rotuloEnvio('Total Geral enviado', 'Total Geral enviado para fila') }}</p>
          <p class="mt-2 text-2xl font-semibold text-green-700">{{ total }}</p>
        </div>

        <div class="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
          <p class="text-sm font-medium text-gray-500">Total Respostas</p>
          <p class="mt-2 text-2xl font-semibold text-gray-700">
            {{ respostas }}
            <span class="text-base text-green-700">({{ porcentagem }}%)</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { colorMixin } from '@/utils/colorMixin';

export default {
  mixins: [colorMixin],
  data() {
    return {
      breadcrumb: [
        {
          url: '/relatorios/relatorio-diario',
          value: 'Relatório diário'
        }
      ],
      route: 'relatorio-envio',
      apilz: window.location.hostname === 'uno.trestto.com.br'
        ? 'https://uno.trestto.com.br/api'
        : process.env.VUE_APP_API,
      moment: moment,
      rangeUserId: '68f7ca952af0dbe968290279',
      centroscusto: [],
      form: {
        centrocusto: null,
        data: moment().startOf('d').format('YYYY-MM-DD'),
        dataInicio: moment().startOf('d').format('YYYY-MM-DD'),
        dataFim: moment().startOf('d').format('YYYY-MM-DD')
      },
      total: 0,
      totalIniciadoManual: 0,
      totalEnvios: 0,
      totalEnviados: 0,
      respostas: 0,
      porcentagem: 0
    }
  },
  computed: {
    isRangeUser() {
      const u = this.$store.state.user

      if (!u) {
        return false
      }

      const efetivo = u.operador
        ? (u.usuario && u.usuario.toString())
        : (u._id && u._id.toString())

      return efetivo === this.rangeUserId
    }
  },
  methods: {
    async list() {
      if (this.isRangeUser) {
        if (!this.form.dataInicio) {
          this.form.dataInicio = moment().startOf('d').format('YYYY-MM-DD')
        }

        if (!this.form.dataFim) {
          this.form.dataFim = this.form.dataInicio
        }
      } else if (!this.form.data) {
        this.form.data = moment().startOf('d').format('YYYY-MM-DD')
      }

      const payload = {
        centrocusto: this.form.centrocusto
      }

      if (this.isRangeUser) {
        payload.dataInicio = this.form.dataInicio
        payload.dataFim = this.form.dataFim || this.form.dataInicio
        payload.data = payload.dataInicio
      } else {
        payload.data = this.form.data
      }

      const listReq = await this.$http.post('/v1/chatV2/relatorio-diario', payload)

      this.total = listReq.data.total
      this.totalIniciadoManual = listReq.data.totalIniciadoManual
      this.totalEnvios = listReq.data.totalEnvios
      this.totalEnviados = listReq.data.totalEnviados
      this.respostas = listReq.data.respostas
      this.porcentagem = listReq.data.porcentagem
    }
  },
  async beforeMount() {
    const centroscustoReq = await this.$http.post('/v1/centrocusto/list', {
      all: true
    })

    this.centroscusto = centroscustoReq.data.data || []

    if (this.$store.state.user.centrocusto) {
      this.form.centrocusto = this.$store.state.user.centrocusto
    }

    this.list()
  }
}
</script>

<style scoped>
.select-icon {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  pointer-events: none;
  color: #9ca3af;
  transform: translateY(-50%);
  transition: transform 0.2s ease, color 0.2s ease;
}

#centrocusto-select::-ms-expand {
  display: none;
}

#centrocusto-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: none !important;
}

.group:focus-within .select-icon {
  color: #6366f1;
  transform: translateY(-50%) rotate(180deg);
}
</style>